<template>
<Popup :width="width" :top="top" :closePopupEvent="closePopupCB">
    <div slot="header">
      <h6 class="login-header">About</h6>
    </div>
    <div class="about-container">
      <div class="about-logo">
        <img src="@/assets/icons/Logo_sdg1.svg" alt="logo"/>
        <p>1.0.0</p>
        <!-- <p>{{AppConfig.appversion.WEB}}</p> -->
      </div>
      <div class="about-text">
        <p class="text-style">
          {{AppConfig.about.abouttext}}
        </p>
      </div>
      <div class="support-text">
        <p>
          <a :href="AppConfig.about.website"
          target="_blank" rel="noopener" aria-label="Web link" class="text-style">
          {{AppConfig.about.website}}
          </a>
        </p>
      </div>
      <div class="about-social-icons">
        <p class="text-style boldStyle">Follow Us</p>
        <a
        :href="AppConfig.about.social.facebook"
        target="_blank" rel="noopener" aria-label="facebook link">
            <img src="@/assets/icons/fb@2x.svg" alt="facebook logo"/>
        </a>
        <a
        :href="AppConfig.about.social.instagram"
        target="_blank" rel="noopener" aria-label="facebook link">
            <img src="@/assets/icons/Ic_insta@2x.svg" alt="instagram logo"/>
        </a>
        <a
        :href="AppConfig.about.social.twitter"
        target="_blank" rel="noopener" aria-label="twitter link">
            <img src="@/assets/icons/twitter_2x.svg" alt="twitter logo"/>
        </a>
        <a
        :href="AppConfig.about.social.youtube"
        target="_blank" rel="noopener" aria-label="youtube link">
            <img src="@/assets/icons/Ic_youtube.svg" alt="youtube logo"/>
        </a>
        <a
        :href="AppConfig.about.social.pinterest"
        target="_blank" rel="noopener" aria-label="pinterest link">
            <img src="@/assets/icons/Ic_pinterest.svg" alt="pinterest logo"/>
        </a>
      </div>
      <div class="about-links">
        <!-- <a @click="open('T')">terms of use</a> -->
        <!-- <a @click="open('P')">privacy policy</a> --> 
        <router-link :to="{ name: 'TermsOfUse' }">
          <span class="terms" @click="closePopup">TERMS OF USE</span>
        </router-link> 
        <router-link :to="{ name: 'PrivacyPolicy' }">
          <span @click="closePopup">PRIVACY POLICY</span>
        </router-link>
      </div>
    </div>
  </Popup>
</template>

<script>
import Utility from '@/mixins/Utility';
import { EventBus } from '@/main';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'About',
  data () {
    return {
      width: '50%',
      top: '50%'
    }
  },
  props: [
    'closePopupCB'
  ],
   computed: {
    ...mapGetters([
      'AppConfig'
    ])
  },
  components: {
    Popup : () => import("@/components/Slots/Popup.vue")    
  },
  methods: {
    closePopup () {
      // Hide the popup
      this.closePopupCB();
    },
    open (page) {
      if (!this.AppConfig) return;
      if (page == 'T') {
          window.open(this.AppConfig.about.tnc)
      } else if (page == 'P') {
          window.open(this.AppConfig.about.privacy)
      }
      // if (page === 'T') {
      //   this.$router.push({ name: 'TermsOfUse'})
      // } else {
      //   this.$router.push({ name: 'PrivacyPolicy'})
      // }
      // this.closePopup()
    }
  },
  mixins: [ Utility ]

}
</script>

<style lang="scss" scoped>
@import '~sass/modules/variables';
.text-style{
  color: #212121;	
  font-family: "ProximanovaRegular";		
  font-size: 16px;
}
.boldStyle{
  font-family: "ProximanovaBold";
}
.support-text{
  text-align: center;
}
.about-container{
  padding: 10%;
  .about-logo{
    text-align: center;
    padding-bottom: 5%;
    img {
      width: 15%;
      // margin: 2% 0;
    }
  }
  .about-text{
    padding-bottom: 5%;
    p{
      text-align: center;
    }
  }
  .about-links{
    text-align: center;
    :nth-child(1){
      // margin-right: 25px;
      margin-right: 5%;
    }
    span{
      color: #4558DD;	
      font-family: "ProximanovaRegular";		
      font-size: 14px;
      text-transform: uppercase;
      cursor: pointer;
      &:hover{
        text-decoration: underline;
      }
    }
  }
  .about-social-icons{
    text-align: center;
    padding: 5% 0;
    p{
      padding: 2%;
    }
    :nth-child(2){
      margin-left: 0px;
    }
    a{
      margin-left: 20px;
      opacity: 0.8;
      &:hover{
        opacity: 1;
      }
    }
    img{
      flex: 1;
      width: 25px;
      height: 25px;
      
      cursor: pointer;    
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Popups/About.vue